export const defaultColumnsByResource: { [type: string]: string[] } = {
    BankAccountTransfer: [
        'BankAccountTransfer.tenantDisplay',
        'BankAccountTransfer.operationTypeValueDisplay',
        'BankAccountTransfer.nameOfBeneficiaryDisplay',
        'BankAccountTransfer.registrationNumberOwner',
        'BankAccountTransfer.registrationNumber',
        'BankAccountTransfer.ownerAccountTypeDisplay',
        'BankAccountTransfer.ownerName',
        'BankAccountTransfer.date',
        'BankAccountTransfer.accountNumber',
        'BankAccountTransfer.amount',
    ],
    BankAccountUser: [
        'BankAccountUser.tenantDisplay',
        'BankAccountUser.registrationNumberOwner',
        'BankAccountUser.ownerName',
        'BankAccountUser.levelDisplay',
        'BankAccountUser.accountNumber',
        'BankAccountUser.ownerAccountTypeDisplay',
        'BankAccountUser.date',
        'BankAccountUser.userIdDisplay',
    ],
    BankAccountBeneficiary: [
        'BankAccountBeneficiary.tenantDisplay',
        'BankAccountBeneficiary.nameOfBeneficiaryDisplay',
        'BankAccountBeneficiary.registrationNumberOwner',
        'BankAccountBeneficiary.accountNumber',
        'BankAccountBeneficiary.registrationNumber',
        'BankAccountBeneficiary.bankAccountData',
        'BankAccountBeneficiary.ownerAccountTypeDisplay',
        'BankAccountBeneficiary.ownerName',
    ],
    BankAccountPayment: [
        'BankAccountPayment.ownerName',
        'BankAccountPayment.tenantDisplay',
        'BankAccountPayment.accountNumber',
        'BankAccountPayment.date',
        'BankAccountPayment.ownerAccountTypeDisplay',
        'BankAccountPayment.registrationNumberOwner',
        'BankAccountPayment.amount',
    ],
    BankAccountTransactionLimits: [
        'BankAccountTransactionLimits.tenantDisplay',
        'BankAccountTransactionLimits.accountNumber',
        'BankAccountTransactionLimits.tenantDisplay',
        'BankAccountTransactionLimits.registrationNumberOwner',
        'BankAccountTransactionLimits.ownerAccountTypeDisplay',
        'BankAccountTransactionLimits.ownerName',
        'BankAccountTransactionLimits.date',
        'BankAccountTransactionLimits.requestedBy',
    ],
};

export const fieldHeaderToList: { [type: string]: { field: string; columns: string[] } } = {
    BankAccountTransfer: {
        field: 'BankAccountTransfer',
        columns: [
            'BankAccountTransfer.tenantDisplay',
            'BankAccountTransfer.operationTypeValueDisplay',
            'BankAccountTransfer.nameOfBeneficiaryDisplay',
            'BankAccountTransfer.registrationNumberOwner',
            'BankAccountTransfer.registrationNumber',
            'BankAccountTransfer.ownerAccountTypeDisplay',
            'BankAccountTransfer.ownerName',
            'BankAccountTransfer.date',
            'BankAccountTransfer.accountNumber',
            'BankAccountTransfer.amount',
            'actions',
        ],
    },
    BankAccountUser: {
        field: 'BankAccountUser',
        columns: [
            'BankAccountUser.tenantDisplay',
            'BankAccountUser.registrationNumberOwner',
            'BankAccountUser.ownerName',
            'BankAccountUser.levelDisplay',
            'BankAccountUser.accountNumber',
            'BankAccountUser.ownerAccountTypeDisplay',
            'BankAccountUser.userIdDisplay',
            'BankAccountUser.date',
            'actions',
        ],
    },
    BankAccountBeneficiary: {
        field: 'BankAccountBeneficiary',
        columns: [
            'BankAccountBeneficiary.tenantDisplay',
            'BankAccountBeneficiary.nameOfBeneficiaryDisplay',
            'BankAccountBeneficiary.registrationNumberOwner',
            'BankAccountBeneficiary.accountNumber',
            'BankAccountBeneficiary.bankAccountData',
            'BankAccountBeneficiary.registrationNumber',
            'BankAccountBeneficiary.ownerAccountTypeDisplay',
            'BankAccountBeneficiary.ownerName',
            'actions',
        ],
    },
    BankAccountPayment: {
        field: 'BankAccountPayment',
        columns: [
            'BankAccountPayment.ownerName',
            'BankAccountPayment.tenantDisplay',
            'BankAccountPayment.date',
            'BankAccountPayment.accountNumber',
            'BankAccountPayment.ownerAccountTypeDisplay',
            'BankAccountPayment.registrationNumberOwner',
            'BankAccountPayment.amount',
            'actions',
        ],
    },
    BankAccountTransactionLimits: {
        field: 'BankAccountTransactionLimits',
        columns: [
            'BankAccountTransactionLimits.tenantDisplay',
            'BankAccountTransactionLimits.accountNumber',
            'BankAccountTransactionLimits.agency',
            'BankAccountTransactionLimits.registrationNumberOwner',
            'BankAccountTransactionLimits.account',
            'BankAccountTransactionLimits.ownerAccountTypeDisplay',
            'BankAccountTransactionLimits.ownerName',
            'BankAccountTransactionLimits.date',
            'BankAccountTransactionLimits.requestedBy',
            'actions',
        ],
    },
};

export const getNameByFilterSelected = (currentFilter: string) => {
    const options: { [type: string]: string } = {
        BankAccountTransfer: 'Beneficiário',
        BankAccountBeneficiary: 'Favorecido',
        BankAccountTransactionLimits: 'Não informado',
    };

    return `${options[currentFilter]}`;
};